import { create } from 'zustand/index';
import { AuthorisedUserStoreType } from '../../Types/AuthorisedUserStoreTypes';
import { defaultAuthorisedUserStoreData } from '../Data/AuthorisedUserData';
import AuthorisedUserReducer from '../Reducers/AuthorisedUserReducer';

const useAuthorisedUserStore = create<AuthorisedUserStoreType>((set) => ({
	...defaultAuthorisedUserStoreData,
	dispatchAuthorisedUserStoreUpdate: (action) => set((state) => AuthorisedUserReducer(state, action)),
}));

export { useAuthorisedUserStore };
